import React from 'react';

import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    InputLabel,
    Stack,
    TextField,
    Tooltip
} from '@mui/material';
import { DeleteFilled } from '@ant-design/icons';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { errorMessage } from 'utils/constants';
import InputFieldErrorMessage from '../../common/InputFieldErrorMessage';
import { MODAL_ACTION_TYPE } from '../../../utils/constants/modal';
import IconButton from '../../@extended/IconButton';

const CreateUpdateNoteModal = ({ note, modalType, onSubmit, onDelete, onClose }) => {
    const initialValues = {
        content: undefined,
        ...note
    };

    const validationSchema = Yup.object().shape({
        content: Yup.string().required(errorMessage.propertyNote.required)
    });

    const handleSubmit = values => {
        onSubmit({ ...values }, onClose);
    };

    const handleDelete = () => {
        onDelete(note, onClose);
    };

    return (
        <Stack sx={{ width: '40vw' }}>
            <DialogTitle>
                {modalType === MODAL_ACTION_TYPE.EDIT ? 'Edit Note' : 'Add New Note'}
            </DialogTitle>
            <Divider />
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
                validateOnChange
                validateOnBlur
                validateOnMount
                // initialTouched={(!users || users.length === 0) && { ownerId: true }}
                // initialErrors={
                //     (!users || users.length === 0) && {
                //         ownerId: errorMessage.vehicle.owner.notExists
                //     }
                // }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    touched,
                    errors,
                    values
                }) => (
                    <>
                        <DialogContent sx={{ p: 2.5 }}>
                            <Grid container columnSpacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <Stack>
                                        <InputLabel htmlFor={'content'}>Note</InputLabel>
                                        <TextField
                                            name="content"
                                            id={'content'}
                                            multiline
                                            rows={2}
                                            fullWidth
                                            required
                                            placeholder="Add Note..."
                                            value={values.content}
                                            inputProps={
                                                {
                                                    // style: { textTransform: 'uppercase' }
                                                }
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={
                                                touched.content && Boolean(errors.content)
                                            }
                                        />
                                        <InputFieldErrorMessage
                                            touched={touched.content}
                                            error={errors.content}
                                        />
                                    </Stack>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Divider />
                        <DialogActions sx={{ p: 2.5 }}>
                            <Grid
                                container
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Grid item>
                                    {modalType === MODAL_ACTION_TYPE.EDIT && (
                                        <Tooltip title="Delete Note" placement="top">
                                            <IconButton
                                                size="large"
                                                color="error"
                                                onClick={handleDelete}
                                            >
                                                <DeleteFilled />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Grid>
                                <Grid item>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Button color="error" onClick={onClose}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            onClick={handleSubmit}
                                        >
                                            {modalType === MODAL_ACTION_TYPE.EDIT
                                                ? 'Update'
                                                : 'Save'}
                                        </Button>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </>
                )}
            </Formik>
        </Stack>
    );
};

export default CreateUpdateNoteModal;
